import React, { FC } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography } from 'transfix-ui/core'

interface ITableEmptyState {
  messageOne: string
  messageTwo: string
}

export const TableEmptyState: FC<ITableEmptyState> = ({ messageOne, messageTwo }) => {
  return (
    <div>
      <Card>
        <Box display='flex' flexDirection='column' alignItems='center'>
          <Box className='tc' my={1}>
            <Typography color='textSecondary' variant='subtitle1'>
              {messageOne}
            </Typography>
            <Typography color='textSecondary' variant='subtitle2'>
              {messageTwo}
            </Typography>
          </Box>
        </Box>
      </Card>
    </div>
  )
}
